import { Box, Card, CardContent, Checkbox, FormControlLabel, Typography } from "@mui/material";
import { GT_COLORS } from "../../../../constants/designTokens.constants";

interface Props {
    checked: boolean;
    onToggle: () => void;
    mode: 'message' | 'reminder';
}

export const SelectAllSection: React.FC<Props> = ({ checked, onToggle, mode }) => {
    const description = mode === 'reminder'
        ? 'Select all mobile app users within your scope. Recipients are resolved dynamically each time the reminder runs.'
        : 'Select all users within your scope. Recipients are resolved at the time the message is sent.';

    return (
        <Card
            elevation={0}
            sx={{
                backgroundColor: checked ? GT_COLORS.primaryLight : 'transparent',
                border: checked ? `1px solid ${GT_COLORS.primary}` : `1px solid ${GT_COLORS.border}`,
                borderRadius: 2.5,
                cursor: 'pointer',
            }}
            onClick={onToggle}
        >
            <CardContent sx={{ p: 2, '&:last-child': { pb: 2 } }}>
                <FormControlLabel
                    onClick={(e) => e.stopPropagation()}
                    control={
                        <Checkbox
                            checked={checked}
                            onChange={onToggle}
                            sx={{ '&.Mui-checked': { color: GT_COLORS.primary } }}
                        />
                    }
                    label={
                        <Box>
                            <Typography sx={{ fontSize: '0.875rem', fontWeight: 500, color: GT_COLORS.textPrimary }}>
                                (Select All Users)
                            </Typography>
                            <Typography sx={{ fontSize: '0.875rem', color: GT_COLORS.textMuted }}>
                                {description}
                            </Typography>
                        </Box>
                    }
                    sx={{ alignItems: 'flex-start', ml: 0 }}
                />
            </CardContent>
        </Card>
    );
};
